import styled from "styled-components";
import { Steps } from "antd";

export const RASteps = ({ ...props }) => {
	return <StyledSteps {...props} />;
};

const StyledSteps = styled(Steps)`
	&.ant-steps .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
		color: #fff !important;
	}
	&.ant-steps .ant-steps-item-wait .ant-steps-item-icon {
		background-color: transparent;
		border: 1px solid #a8a8a8;
	}
`;
